import React from "react";
import { Headphones, BookOpen, Users, MessageCircleQuestion } from "lucide-react";

const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden hero-accent"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Text */}
          <div className="lg:col-span-7 fade-up">
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] font-semibold text-[#D97706]">
              <span className="h-px w-8 bg-[#D97706]" />
              A Podcast, Book &amp; Encouragement Platform
            </span>
            <h1 className="mt-6 font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-slate-900">
              Real Questions.{" "}
              <span className="block text-[#0369A1]">Honest Answers.</span>
              <span className="text-[#D97706]">Practical Hope.</span>
            </h1>
            <p className="mt-7 text-base sm:text-lg leading-relaxed text-slate-600 max-w-2xl">
              Ask Chaplain Derrick is a podcast and teaching platform hosted by
              Chaplain Derrick Hall. Drawing on <em>From Diagnosis to Goodbye</em>{" "}
              and his experience as a hospice and corporate chaplain, Derrick
              offers practical encouragement for grief, caregiving,
              relationships, emotional stress, life changes, and supporting
              people in the workplace. It welcomes anyone seeking hope and
              perspective through difficult seasons and ordinary days.
            </p>

            <div className="mt-9 flex flex-wrap gap-3">
              <a
                href="#podcast"
                data-testid="hero-listen-podcast"
                className="inline-flex items-center gap-2 bg-[#0369A1] hover:bg-[#0284C7] text-white rounded-full px-6 py-3 text-sm font-medium transition-colors"
              >
                <Headphones size={16} /> Listen to the Podcast
              </a>
              <a
                href="https://www.amazon.com/Diagnosis-Goodbye-Restoring-Patients-Through/dp/0980212723"
                target="_blank"
                rel="noreferrer noopener"
                data-testid="hero-buy-book"
                className="inline-flex items-center gap-2 bg-[#D97706] hover:bg-[#B45309] text-white rounded-full px-6 py-3 text-sm font-medium transition-colors"
              >
                <BookOpen size={16} /> Buy the Book on Amazon
              </a>
              <a
                href="#classes"
                data-testid="hero-join-class"
                className="inline-flex items-center gap-2 bg-white border border-slate-200 hover:border-[#0369A1] text-slate-800 rounded-full px-6 py-3 text-sm font-medium transition-colors"
              >
                <Users size={16} /> Join a Class
              </a>
              <a
                href="#submit"
                data-testid="hero-submit-question"
                className="inline-flex items-center gap-2 bg-white border border-slate-200 hover:border-[#D97706] text-slate-800 rounded-full px-6 py-3 text-sm font-medium transition-colors"
              >
                <MessageCircleQuestion size={16} /> Submit a Question
              </a>
            </div>

            <div className="mt-10 flex items-center gap-6 text-xs text-slate-500">
              <div className="flex -space-x-2">
                <div className="h-8 w-8 rounded-full bg-[#BAE6FD] border-2 border-white" />
                <div className="h-8 w-8 rounded-full bg-amber-100 border-2 border-white" />
                <div className="h-8 w-8 rounded-full bg-slate-200 border-2 border-white" />
              </div>
              <p>
                For listeners and readers navigating grief, caregiving,
                workplace stress, relationships, and everyday questions of
                meaning.
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="lg:col-span-5 fade-up fade-up-delay-2 relative">
            <div className="relative">
              <div className="absolute -inset-4 rounded-[2rem] bg-[#F0F9FF]" aria-hidden="true" />
              <img
                src="https://images.unsplash.com/photo-1567596296091-0a257a028e72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                alt="Podcast microphone on a quiet desk"
                className="relative rounded-[1.75rem] w-full h-[520px] object-cover shadow-[0_30px_60px_-25px_rgba(15,23,42,0.25)]"
                data-testid="hero-image"
              />
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-4 border border-slate-100 max-w-[230px] hidden sm:block">
                <p className="text-xs uppercase tracking-widest text-[#D97706] font-semibold">
                  Now Streaming
                </p>
                <p className="font-heading text-slate-900 mt-1 text-sm leading-snug">
                  &ldquo;When Grief Doesn&apos;t Have Words.&rdquo;
                </p>
                <p className="text-xs text-slate-500 mt-1">Episode 12 · 24 min</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
